import HeroSection from "../components/HeroSection";
import ExploreEvents from "../components/ExploreEvents";
import EventGrid from "../components/EventGrid";
import Testimonials from "../components/Testimonials";

const HomePage = () => {
  return (
    
    <>
      <HeroSection />
      <ExploreEvents />
      <EventGrid />
      <Testimonials />
    </>
  );
};

export default HomePage;
